import MultiSelectOptions from "./MultiSelectOptions";
import ResearchUploadAffordance from "./ResearchUploadAffordance";
import ResourceLinkCard from "./ResourceLinkCard";
import SingleSelectOptions from "./SingleSelectOptions";
import ThinkingIndicator from "./ThinkingIndicator";
import Markdown from "@app/components/Markdown/Markdown";
import type { ResponseItem } from "@app/config/agentWebSocket";
import type { ChatMessage } from "@lib/agent/types";
import { Paper, Stack } from "@mantine/core";

function ExtraItem({ item, onSend }: { item: ResponseItem; onSend: (v: string) => void }) {
  switch (item.action) {
    case "resource_link":
      return <ResourceLinkCard label={item.resource_link.label} url={item.resource_link.url} />;
    case "question_select_multi":
      return <MultiSelectOptions options={item.options} onSend={onSend} />;
    case "question_select_single":
      return <SingleSelectOptions options={item.options} onSend={onSend} />;
    case "question_upload":
      return <ResearchUploadAffordance placeholder={item.input_placeholder} onSend={onSend} />;
    case "question_open":
    default:
      return null;
  }
}

export default function AgentChatMessage({
  message,
  isStreaming,
  onSend
}: {
  message: ChatMessage;
  isStreaming: boolean;
  onSend: (v: string) => void;
}) {
  return (
    <Stack flex={1} w="100%">
      <Paper py={0} px={0} radius="sm" bg="transparent" shadow="none" withBorder={false}>
        <Markdown>{message.content}</Markdown>

        {isStreaming && <ThinkingIndicator />}
      </Paper>
      {message.extras?.map((item, i) => (
        <ExtraItem key={i} item={item} onSend={onSend} />
      ))}
    </Stack>
  );
}
